<template>
    <div @click="handleClick" class="flex items-center justify-between">
        <span class="flex flex-col flex-grow pr-4">
            <span class="text-gray-700 dark:text-slate-200" :id="aria + '-label'">
                <slot name="label" />
            </span>
            <span class="text-gray-500 dark:text-slate-300 text-sm" :id="aria + '-description'">
                <slot name="description" />
            </span>
        </span>
        <button
            type="button"
            :class="[status ? 'focus:ring-green-500 dark:focus:ring-green-900 bg-green-500' : 'focus:ring-gray-300 dark:focus:ring-gray-900 bg-gray-200 dark:bg-gray-400']"
            class="relative inline-flex shrink-0 w-11 h-6 border-2 border-transparent rounded-full focus:outline-none cursor-pointer transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-offset-2"
            role="switch"
            aria-checked="false"
            :aria-labelledby="aria + '-label'"
            :aria-describedby="aria + '-description'"
            @click.stop="handleClick"
        >
            <span aria-hidden="true" :class="[status ? 'translate-x-5 bg-green-100 dark:bg-green-800' : 'translate-x-0 bg-white']" class="inline-block w-5 h-5 rounded-full shadow pointer-events-none transform transition duration-200 ease-in-out ring-0"></span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        aria: {
            required: true,
            type: String,
        },
    },

    computed: {
        status: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit("input", value)
            },
        },
    },

    methods: {
        handleClick() {
            this.toggle()
            if ("vibrate" in navigator) {
                navigator.vibrate(500) // Vibrate for 500 milliseconds
            }
        },
        toggle() {
            this.status = !this.status
        },
    },
}
</script>
